/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */
const inputState = Object.freeze({
  hasCursor: 'hasCursor',
  hasValue: 'hasValue',
  noValue: 'noValue',
});

export const TimeInputStateHandlerMixin = (superClass) =>
  class extends superClass {
    static get properties() {
      return {
        timeInputState: {
          type: String,
        },
      };
    }
    connectedCallback() {
      super.connectedCallback();
      this.addEventListener('focus', this._updateInputFieldStateIfFocused.bind(this));
      this.addEventListener('blur', this._updateInputFieldStateBasedOnInputValue.bind(this));
    }
    _updateInputFieldStateIfFocused(e) {
      let element = e.currentTarget;
      if (!element.disabled && element.timeInputState !== inputState.hasCursor) {
        element.timeInputState = inputState.hasCursor;
        this.classList.remove('noValue');
        this.classList.remove('hasValue');
        this.classList.add(inputState.hasCursor);
      } else {
        e.stopPropagation();
      }
    }
    _updateInputFieldStateBasedOnInputValue(e) {
      let element = e ? e.currentTarget : this;
      if (element) {
        if (!element.responsive) {
          element.active = false;
        }
        element.timeInputState =
          String(this.h).length > 0 ||
          String(this.m).length > 0 ||
          String(this.s).length > 0 ||
          String(this.amPm).length > 0
            ? inputState.hasValue
            : inputState.noValue;
        if (element.timeInputState === inputState.hasValue) {
          this.classList.remove('noValue');
          this.classList.remove('hasCursor');
          this.classList.add('hasValue');
        } else {
          this.classList.remove('hasValue');
          this.classList.remove('hasCursor');
          this.classList.add('noValue');
        }
      } else {
        if (e) {
          e.stopPropagation();
        }
      }
    }
  };
